import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import AttachFile from "../../components/Comman/AttachFile";
import { ButtonCompo } from "../../components/Comman/Button";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import { redColor, titleColor } from "../../config/ColorObj";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const AttachementPopUp = ({
    handleCloses,
    open,
    onAddImage,
}) => {
    const [fileName, setFileName] = React.useState("");

    const handleClose = () => {
        handleCloses();
    };

    const changeH = (fileName) => {
        setFileName(fileName);
    };

    const onAddImagePopUp = () => {
        onAddImage(fileName)
    };


    const onClickViewPreviewMethod = (e, row) => {
        e.stopPropagation();
        const url = URL.createObjectURL(row);
        window.open(url);
    }

    return (
        <>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        width: "70%",
                        borderRadius: "12px",
                    },
                }}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Add Attachement
                </BootstrapDialogTitle>
                <DialogContent
                    dividers
                    sx={{ backgroundColor: " #f7f8fa" }}
                >

                    <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        spacing={0.5}
                        sx={{
                            alignItems: 'flex-start',
                            flexWrap: { xs: 'wrap', md: 'nowrap' }
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                    padding: "10px 5px 10px 5px",
                                    justifyContent: 'flex-start',
                                }}
                            >
                                <Grid container spacing={1}>

                                    <Grid
                                        item
                                        sm={12}
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        container
                                        justifyContent="flex-star"
                                    >
                                        <Grid
                                            item
                                            sm={6}
                                            xs={12}
                                            md={6}
                                            lg={6}
                                            container
                                            alignItems="center"
                                            justifyContent="flex-start"
                                        >
                                            <Grid item xs="auto">
                                                <LabelCompo
                                                    className="text-black"
                                                    style={{ fontSize: 16, color: redColor }}
                                                    label="* "
                                                />
                                                <LabelCompo
                                                    className="text-black"
                                                    style={{ fontSize: 16, color: titleColor }}
                                                    label="Select Image:"
                                                />
                                            </Grid>
                                            <Grid item xs="auto" style={{ marginLeft: 16 }}>
                                                <AttachFile
                                                    name={"file"}
                                                    fileName={changeH}
                                                />
                                            </Grid>
                                            {fileName !== "" && (
                                                <>
                                                    <Grid item xs="auto" style={{ marginLeft: 8 }}>
                                                        <span>{fileName.name}</span>
                                                        &nbsp;&nbsp;
                                                        <MyComponentWithIconProps
                                                            statusImage={VisibilityIcon}
                                                            color="primary"
                                                            fontSize="medium"
                                                            title="View"
                                                            onClick={(e) => onClickViewPreviewMethod(e, fileName)}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        sx={{ justifyContent: "flex-end" }}
                                    >
                                        <ButtonCompo
                                            size="medium"
                                            type="submit"
                                            variant="contained"
                                            name={"Add Image"}
                                            onClick={onAddImagePopUp}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    showNotification,
    showLoador,
    showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachementPopUp);
